/**
 * Main application initialization entry point.
 */

'use strict';

var app = require('mag-app');


app.once('load', function () {
    require('spa-gettext').load({name: core.environment.language}, function () {
        app.flags = {
            modalActive:     false,
            favoritesActive: false,
            webWindowActive: true,
            ignoreMessages:  false
        };

        app.data = {
            currentUrl:       '',
            currentUrlTitle:  '',
            mediaContentData: {}
        };

        app.pages = {
            main: require('./pages/main')
        };

        app.storage = require('./modules/storage').prepareStorage(core.plugins.ufsJson.loadSync());
        app.route(app.pages.main);
        app.ready();
    });
});
